import { render } from "./NotificationMessage.vue?vue&type=template&id=0033b5f6&scoped=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"

import "./NotificationMessage.vue?vue&type=style&index=0&id=0033b5f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0033b5f6"]])

export default __exports__